import React from 'react';
import './LocationForm.css';

function LocationForm({ form, onChange, onSubmit, isSubmitting }) {
  return (
    <div className="form-container">
      <input
        name="location_name"
        placeholder="Location Name"
        value={form.location_name}
        onChange={onChange}
        style={{ marginBottom: '8px', display: 'block' }}
      />
      <input
        name="address_line1"
        placeholder="Address Line 1"
        value={form.address_line1}
        onChange={onChange}
        style={{ marginBottom: '8px', display: 'block' }}
      />
      <input
        name="address_line2"
        placeholder="Address Line 2"
        value={form.address_line2}
        onChange={onChange}
        style={{ marginBottom: '8px', display: 'block' }}
      />
      <input
        name="city"
        placeholder="City"
        value={form.city}
        onChange={onChange}
        style={{ marginBottom: '8px', display: 'block' }}
      />
      <input
        name="latitude"
        placeholder="Latitude"
        type="number"
        step="0.0000001"
        value={form.latitude}
        onChange={onChange}
        style={{ marginBottom: '8px', display: 'block' }}
      />
      <input
        name="longitude"
        placeholder="Longitude"
        type="number"
        step="0.0000001"
        value={form.longitude}
        onChange={onChange}
        style={{ marginBottom: '8px', display: 'block' }}
      />
      <button onClick={onSubmit} disabled={isSubmitting}>
        {isSubmitting ? 'Saving...' : 'Save Location'}
      </button>
    </div>
  );
}

export default LocationForm;
